import React, { useState } from "react";
import { Stack, Group, TextInput, Button, Text, Center } from "@mantine/core";
import { IconCheck, IconSend } from "@tabler/icons-react";
import { useSalon } from "../../context/SalonContext";
import { useApp } from "../../context/AppContext";

function EmailReceiptForm({ paymentIntentId, customerEmail }) {
  const { businessInfo } = useSalon();
  const { updatePaymentIntent } = useApp();
  const [emailInput, setEmailInput] = useState(customerEmail || "");
  const [isSendingEmail, setIsSendingEmail] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [error, setError] = useState(null);

  const handleSendReceipt = async () => {
    setIsSendingEmail(true);
    setError(null);
    try {
      await updatePaymentIntent({
        paymentIntentId,
        accountId: businessInfo.stripe_connect_account_id,
        receiptEmail: emailInput,
      });
      setEmailSent(true);
    } catch (err) {
      setError(`Failed to send email: ${err.message}`);
    } finally {
      setIsSendingEmail(false);
    }
  };

  return (
    <Stack spacing="md">
      <Text ta="center" size="lg">
        Send email receipt to customer?
      </Text>

      <Center>
        <Group spacing="xs" style={{ width: "400px" }}>
          <TextInput
            placeholder="Enter email address"
            value={emailInput}
            onChange={(e) => setEmailInput(e.currentTarget.value)}
            disabled={isSendingEmail || emailSent}
            rightSection={
              emailSent ? <IconCheck size={16} color="green" /> : null
            }
            error={error}
            style={{ flex: 1 }}
          />
          <Button
            onClick={handleSendReceipt}
            loading={isSendingEmail}
            disabled={!emailInput || emailSent}
            leftSection={<IconSend size={16} />}
          >
            Send
          </Button>
        </Group>
      </Center>

      {emailSent && (
        <Text c="green" size="sm" ta="center">
          Receipt sent successfully!
        </Text>
      )}
    </Stack>
  );
}

export default EmailReceiptForm;
